import React from "react";
import "./HeroA.css"; // CSS für das Styling
import MOON from "./../../images/moon.jpg";
import Logo1 from "./../../images/mllogo1.png";

const Hero = () => {
  return (
    <div className="hero-section">
      <div className="hero-background-stars"></div>
      <div className="hero-content">
        <div className="hero-moon-container">
          <div
            className="hero-rotating-moon"
            style={{ backgroundImage: `url(${MOON})` }}
            alt="Moon Lounge Moon"
          ></div>
        </div>
        <img
          src={Logo1}
          alt="Moon Lounge Logo"
          className="hero-image-logo"
        />
        <p className="hero-text">
          Erlebe eine entspannte Atmosphäre, fantastische Shishas und gute Musik.
        </p>
        <div className="hero-social-links">
          <a
            href="https://www.instagram.com/moon.lounge0711/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              alt="Instagram Logo Moon Lounge"
              className="hero-social-icon"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
